import React from 'react';
import V3SettlementView from '../components/V3SettlementView';

const V3SettlementApp = (props) => (
  <V3SettlementView {...props} />
);

export default V3SettlementApp;
